<div #slider class="scrolling-wrapper"
     (mousedown)="mouseDown($event)"
     (mouseup)="mouseUp($event)"
     (mousemove)="mouseMove($event)">
  <ng-content></ng-content>
</div>
